import { trackEvent } from './firebase';

export const openQuoteChat = () => {
    trackEvent('generate_lead', { method: 'chat' });
    if (typeof window !== 'undefined' && window.Tawk_API && window.Tawk_API.maximize) {
        window.Tawk_API.maximize();
    }
};

export const setChatWidgetVisible = (visible) => {
    const api = typeof window !== 'undefined' ? window.Tawk_API : null;
    const toggle = api && (visible ? api.showWidget : api.hideWidget);
    if (toggle) toggle();
};

export const scrollPageTop = () => {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }
};
